export default __webpack_public_path__ + "static/media/ProximaNovaBold.fcaab252.otf";